import {$} from '../util/jq';

export default function initAnswersMods() {
  const collectedAmountItems = $(".answers-list").find("tr[data-appkey$='_collectedAmount']");
  const paymentAmountItems = $(".answers-list").find("tr[data-appkey$='_paymentAmount']");

  collectedAmountItems.each( function() {
    const appKey = $(this).attr('data-appkey');
    const key = appKey.split("_")[0];
    $(this).find(".questionText").html( key.charAt(0).toUpperCase() + key.slice(1) + " | Collected Amount" );
  });

  paymentAmountItems.each( function() {
    const appKey = $(this).attr('data-appkey');
    const key = appKey.split("_")[0];
    $(this).find(".questionText").html( key.charAt(0).toUpperCase() + key.slice(1) + " | Payment Amount" );
  });
};



// WEBPACK FOOTER //
// ./src/main/js/pages/_initAnswerMods.js